module.exports = "/static-assets/_next/static/images/glow-behindtv-f6438c9c97fe5affa33ea0f700cbcc2a.png";